import React, { useState } from 'react';
import { CakeIcon, AdjustmentsHorizontalIcon, ClipboardDocumentListIcon } from '@heroicons/react/24/outline';
import CakeSizesTab   from '../components/Cakes/CakeSizesTab';
import CakeOptionsTab from '../components/Cakes/CakeOptionsTab';
import CakeOrdersTab  from '../components/Cakes/CakeOrdersTab';

type TabId = 'orders' | 'sizes' | 'options';

const TABS: { id: TabId; label: string; icon: React.ComponentType<{ className?: string }> }[] = [
    { id: 'orders',  label: 'Cake Orders',     icon: ClipboardDocumentListIcon },
    { id: 'sizes',   label: 'Sizes & Pricing', icon: CakeIcon },
    { id: 'options', label: 'Options',          icon: AdjustmentsHorizontalIcon },
];

export default function CakeConfigPage() {
    const [activeTab, setActiveTab] = useState<TabId>('orders');

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-semibold text-stone-900">Build my Cake</h1>
                <p className="mt-1 text-sm text-stone-500">
                    Manage cake orders, sizes, options and pricing for the Build my Cake feature
                </p>
            </div>

            <div className="rounded-2xl bg-white border border-stone-200 shadow-sm overflow-hidden">
                <div className="border-b border-stone-200">
                    <nav className="flex gap-8 px-6" aria-label="Tabs">
                        {TABS.map(tab => (
                            <button key={tab.id} onClick={() => setActiveTab(tab.id)}
                                    className={`inline-flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                                        activeTab === tab.id
                                            ? 'border-[#ee2b74] text-[#ee2b74]'
                                            : 'border-transparent text-stone-500 hover:text-stone-700 hover:border-stone-300'
                                    }`}>
                                <tab.icon className="h-4 w-4" />
                                {tab.label}
                            </button>
                        ))}
                    </nav>
                </div>

                <div className="p-6">
                    {activeTab === 'orders'  && <CakeOrdersTab />}
                    {activeTab === 'sizes'   && <CakeSizesTab />}
                    {activeTab === 'options' && <CakeOptionsTab />}
                </div>
            </div>
        </div>
    );
}